import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // localStorage
import { combineReducers } from '@reduxjs/toolkit';

// Import slices
import authReducer from './slices/authSlice';
import projectReducer from './slices/projectSlice';
import applicationSetupReducer from './slices/applicationSetupSlice';
import trustIndexReducer from './slices/trustIndexSlice';
import riskReducer from './slices/riskSlice';
import metricsReducer from './slices/metricsSlice';
import datasetReducer from './slices/datasetSlice';
import testEvaluationReducer from './slices/testEvaluationSlice';
import testScoreReducer from './slices/testScoreSlice';

// Combine all reducers
const rootReducer = combineReducers({
  auth: authReducer,
  project: projectReducer,
  applicationSetup: applicationSetupReducer,
  trustIndex: trustIndexReducer,
  risk: riskReducer,
  metrics: metricsReducer,
  dataset: datasetReducer,
  testEvaluation: testEvaluationReducer,
  testScore: testScoreReducer,
});

// Redux Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'project'], // Only persist auth and current project
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);
